import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { ADMIN_BUTTON_SX } from "./adminUi";
import { AdminDialog, AdminTextField } from "./adminForm";

var COMMENT_MAX = 1000;

/** HR review comment; required for both Approve and Re-submit. */
function CommentDialog(props) {
  var [comment, setComment] = useState("");
  var [touched, setTouched] = useState(false);

  useEffect(
    function () {
      if (props.open) {
        setComment(props.initialComment || "");
        setTouched(false);
      }
    },
    [props.open, props.initialComment]
  );

  var trimmed = comment.trim();
  var error = touched && !trimmed ? "Comment is required" : "";

  function handleSubmit(e) {
    e.preventDefault();
    setTouched(true);
    if (!trimmed || props.busy) return;
    props.onSubmit(trimmed);
  }

  return (
    <AdminDialog
      open={props.open}
      onClose={props.onClose}
      busy={props.busy}
      width={600}
      title="Add Comment"
      titleId="admin-comment-title"
      onSubmit={handleSubmit}
      actions={
        <>
          <Button variant="outlined" onClick={props.onClose} disabled={props.busy} sx={ADMIN_BUTTON_SX.outlined}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={props.busy}
            startIcon={props.busy ? <CircularProgress size={14} color="inherit" /> : null}
            sx={ADMIN_BUTTON_SX.contained}
          >
            {props.submitLabel}
          </Button>
        </>
      }
    >
      <AdminTextField
        label="Comment"
        required
        name="comment"
        placeholder="Write Comment"
        multiline
        minRows={5}
        maxRows={10}
        autoFocus
        value={comment}
        onChange={function (e) {
          setComment(e.target.value.slice(0, COMMENT_MAX));
        }}
        onBlur={function () {
          setTouched(true);
        }}
        error={error}
        hint={comment.length + "/" + COMMENT_MAX + " characters"}
        sx={{
          "& .MuiOutlinedInput-root": { p: 0, alignItems: "flex-start", minHeight: 140 },
          "& .MuiOutlinedInput-input": { py: "10px", px: "12px" },
        }}
      />
    </AdminDialog>
  );
}

export default CommentDialog;
